import React from 'react'
import {createRoot} from 'react-dom/client'
import './assets/css/tailwind.output.css'
import App from './App'

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App tab="home" />);